import { ReactElement } from 'react';
import { FormHorizontal } from '~/components/form/layout';
import { InputCardOption } from '~/components/input/InputCards';
import ZodFieldCards from '~/components/zod/ZodFieldCards';
import { BreOrderType } from '~/tenants/bre/model/enums';
import { bre_is_aerial_video, BreAerialType } from '~/tenants/bre/performable/aerial/BreAerialConfig';
import BreAerialJob from '~/tenants/bre/performable/aerial/BreAerialJob';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';

export default function BreAerialFields({ context }: { context: BreOrderContext }): ReactElement {
  const typeOptions = Object.values(BreAerialType)
    .filter((value) => (context.metadata.type === BreOrderType.LONG_TERM ? !bre_is_aerial_video(value) : true))
    .map<InputCardOption>((value) => ({
      title: BreAerialJob.calculateName(context, value),
      cost: BreAerialJob.calculateIncreasedRate(context, value).toFixed(2),
      value,
    }));

  return (
    <FormHorizontal name="type" label="Aerial Package" required>
      <ZodFieldCards name="type" cols={2} options={typeOptions} required />
    </FormHorizontal>
  );
}
